import React, { useState, useEffect } from "react";

import {
  DataGridPro,
  useGridApiRef,
  gridSortedRowEntriesSelector
} from "@mui/x-data-grid-pro";

import { Button, Checkbox } from "@mui/material";
function MyTable(props) {
  let [rowData, setData] = useState([]);
  const apiRef = useGridApiRef();

  useEffect(() => {}, [props]);

  const handleToggleAllCompleted = (value, target) => {
    // console.log(value)
    // console.log(target)
  };

  const getdata = () => {
    console.log("in");
    let x = [
      { name: "Cussvc", None: false, Read: true, Update: false, id: 0 },
      { name: "Cussvc L2", None: true, Read: false, Update: false, id: 1 },
      { name: "Design", None: true, Read: false, Update: false, id: 2 },
      { name: "Design L2", None: true, Read: false, Update: false, id: 3 },
      { name: "Guest", None: true, Read: false, Update: false, id: 4 },
      { name: "Managers", None: true, Read: false, Update: false, id: 5 }
    ];
    setData(x);
  };
  const afterdata = () => {
    console.log("after----------------------------------------------");
    console.log(rowData);
  };
  const handleToggleSingle = (value, target) => {
    setData(function (prevRows) {
      if (target === "None") {
        prevRows[value].None = !prevRows[value].None;
        prevRows[value].Read = false;
        prevRows[value].Update = false;
      } else if (target === "Read") {
        prevRows[value].None = false;
        prevRows[value].Read = !prevRows[value].Read;
        prevRows[value].Update = false;
      } else if (target === "Update") {
        prevRows[value].None = false;
        prevRows[value].Read = false;
        prevRows[value].Update = !prevRows[value].Update;
      }

      // })
      setData(prevRows);
    });
  };
  let [colDef, setColDef] = useState([
    // { field: 'icon1',headerName :" ",width:1 },
    { field: "name", headerName: "Access Group", sortable: false, width: 140 },
    {
      field: "delete",
      type: "actions",
      width: 100,
      renderCell: (params) => (
        <Checkbox
          checked={params.row.None}
          onChange={(e) => handleToggleSingle(params.id, "None")}
          inputProps={{ "aria-label": "controlled" }}
        />
      ),
      renderHeader: () => (
        <>
          <Checkbox
            checked={
              gridSortedRowEntriesSelector(apiRef.current.state).every(
                (r) => r.model.Read
              ) || false
            }
            style={{ paddingLeft: "4px" }}
            inputProps={{ "aria-label": "controlled" }}
          />
          None
        </>
      )
    },
    {
      field: "Read",
      // editable: true,
      width: 100,
      sortable: false,
      hideSortIcons: true,
      // headerClassName: 'checkbox-column',
      renderCell: (params) => (
        <Checkbox
          checked={params.row.Read}
          onChange={(e) => handleToggleSingle(params.id, "Read")}

          // inputProps={{ 'aria-label': 'controlled' }}
        />
      ),
      renderHeader: () => (
        <>
          <Checkbox
            checked={
              gridSortedRowEntriesSelector(apiRef.current.state).every(
                (r) => r.model.Read
              ) || false
            }
            disableRipple
            disableFocusRipple
            // onChange={e => handleToggleAllCompleted(e.target.checked, "None")}
            style={{ paddingLeft: "4px" }}
            inputProps={{ "aria-label": "controlled" }}
          />
          Read
        </>
      )
    },
    {
      field: "Update",
      // editable: true,
      width: 100,
      sortable: false,
      hideSortIcons: true,
      // headerClassName: 'checkbox-column',
      renderCell: (params) => (
        <Checkbox
          checked={params.row.Update}
          onChange={(e) => handleToggleSingle(params.id, "Update")}

          // inputProps={{ 'aria-label': 'controlled' }}
        />
      ),
      renderHeader: () => (
        <>
          <Checkbox
            checked={
              gridSortedRowEntriesSelector(apiRef.current.state).every(
                (r) => r.model.Update
              ) || false
            }
            // disableRipple
            // disableFocusRipple
            // onChange={e => handleToggleAllCompleted(e.target.checked, "None")}
            style={{ paddingLeft: "4px" }}
            inputProps={{ "aria-label": "controlled" }}
          />
          Update
        </>
      )
    }
  ]);

  return (
    <>
      <Button onClick={(e) => getdata()}>getData</Button>

      <Button onClick={(e) => afterdata()}>afterDataChange</Button>
      <DataGridPro
        apiRef={apiRef}
        columnBuffer={10}
        hideFooter={true}
        columns={colDef}
        rowHeight={30}
        autoHeight
        disableColumnMenu={true}
        rows={rowData}
      />
    </>

    //  </div>
  );
}

export default MyTable;
